import { dateWithoutTimezone } from "utils/dateWithoutTimezone";

export function getDate(date: string | null | undefined): Date | null {
  if (date) {
    return dateWithoutTimezone(date);
  }
  return null;
}
